import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { getOutfitFormulas } from '@shared/api/outfitGenerator.js'

export const useOutfitGeneratorStore = defineStore('outfitGenerator', () => {
  const exampleItems = ref([
    {
      id: 1,
      name: 'Item 1',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 2,
      name: 'Item 2',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 3,
      name: 'Item 3',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 4,
      name: 'Item 4',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 5,
      name: 'Item 5',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 6,
      name: 'Item 6',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 7,
      name: 'Item 7',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 8,
      name: 'Item 8',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 9,
      name: 'Item 9',
      image: 'https://via.placeholder.com/150',
    },
    {
      id: 10,
      name: 'Item 10',
      image: 'https://via.placeholder.com/150',
    }
  ])
  const outfitFormulas = ref([])
  const outfitFormulasLoaded = ref(false)
  const selectedFormula = ref(null)

  const hideOutfitFormulas = computed(() => outfitFormulas.value.length === 0 && outfitFormulasLoaded.value)

  const slotMap = { 1: 'a', 2: 'b', 3: 'c', 4: 'f' }

  async function fetchOutfitFormulas () {
    outfitFormulasLoaded.value = false
    const response = await getOutfitFormulas()
    outfitFormulas.value = response.data
    outfitFormulasLoaded.value = true
  }

  const findDefaultStyleColorsForFormula = (formula) => {
    const defaultStyleColors = {}

    for (const slot of formula.slots) {
      const key = slotMap[slot.slotNumber]
      if (key && slot.defaultStyleColor) {
        defaultStyleColors[key] = slot.defaultStyleColor
      }
    }
    
    return defaultStyleColors
  }
  
  const defaultStyleColorsFlatlayImages = (defaultStyleColors) => {
    const flatlayImages = {}
    for (const key in defaultStyleColors) {
      const styleColor = defaultStyleColors[key]
      if (styleColor?.images?.flatLay?.[0]?.url) {
        flatlayImages[key] = styleColor.images.flatLay[0].url
      }
    }
    return flatlayImages
  }

  const fullDefaultOutfitImages = (formula) => {
    const defaultStyleColors = findDefaultStyleColorsForFormula(formula)
    const flatlayImages = defaultStyleColorsFlatlayImages(defaultStyleColors)
    
    return {
      ...flatlayImages,
      accessoryImageUrl: formula.accessoryImageUrl || null
    }
  }

  const selectFormula = (formula) => {
    selectedFormula.value = formula
  }

  return {
    exampleItems,
    outfitFormulas,
    outfitFormulasLoaded,
    selectedFormula,
    hideOutfitFormulas,
    fetchOutfitFormulas,
    findDefaultStyleColorsForFormula,
    defaultStyleColorsFlatlayImages,
    fullDefaultOutfitImages,
    selectFormula,
  }
})